<template>
  <div>
    <v-btn
      rounded
      fab
      small
      color="#FFF"
      class="go-to-top"
      :class="{ 'event-triggered' : jobCommentEvent }"
      :style="{ display: showGoToTopButton }"
      @click="goToTop()"
    >
      <v-icon color="#37474F">
        mdi-arrow-up
      </v-icon>
    </v-btn>
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-text-field
        v-model="comment"
        class="chat-text-style"
        outlined
        dense
        background-color="#FFFFFF"
        light
        color="#37474f"
        placeholder="Add comment"
      >
        <template slot="append">
          <v-btn
            fab
            small
            elevation="0"
            color="transparent"
            class="mr-1"
            @click="addAttachment()"
          >
            <v-icon color="#929292">
              mdi-attachment
            </v-icon>
          </v-btn>
          <v-btn
            fab
            small
            elevation="0"
            color="transparent"
            @click="addComment()"
          >
            <v-icon color="#929292">
              mdi-send
            </v-icon>
          </v-btn>
        </template>
      </v-text-field>
      <input
        ref="fileInput"
        type="file"
        style="display: none;"
        accept="image/png, image/jpeg, image/jpg"
        @change="handleFileChange"
      >
    </v-form>
    <div
      ref="commentSection"
      class="comment-section mt-3"
      @scroll="handleScroll"
    >
      <div
        v-if="commentsAvailable"
      >
        <div class="text-center">
          <v-progress-circular
            v-if="lazyLoader"
            size="25"
            :width="1"
            color="#101010"
            indeterminate
          />
        </div>
        <div
          v-for="(item, index) in allComments"
          :key="index"
          class="chat-section mb-4"
          :class="{ 'text-right': checkUser(item.sent_user) }"
        >
          <div
            class="chats-style"
            :class="{ 'chat-style-user': checkUser(item.sent_user) }"
          >
            <div :class="{ 'text-left': checkUser(item.sent_user) }">
              <span
                v-if="item.sent_user !== null"
                class="name-style"
              >{{ item.sent_user.first_name }} {{ item.sent_user.last_name }}</span>
              <span
                v-else
                class="name-style"
              >N/A</span>
            </div>
            <v-img
              v-if="item.document_file !== null"
              class="image-style"
              :lazy-src="getImageUrl(item.document_file.file_path)"
              :src="getImageUrl(item.document_file.file_path)"
              @loadstart="imageLoad = true"
              @load="imageLoad = false"
            >
              <template #placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular
                    color="grey-lighten-4"
                    indeterminate
                  />
                </div>
              </template>
            </v-img>
            <div
              class="comment-text"
              :class="{ 'text-left': checkUser(item.sent_user) }"
            >
              <p>{{ item.comment }}</p>
            </div>
          </div>
          <br>
          <span class="time-style">{{ item.created_at | fromNow }}</span>
        </div>
        <v-btn
          v-if="remainingButton"
          :disabled="buttonLoader"
          outlined
          color="#37474F"
          width="100%"
          @click="getremainingButton()"
        >
          <v-progress-circular
            v-if="buttonLoader"
            size="20"
            :width="1"
            color="#101010"
            indeterminate
          />
          <font v-else>
            View {{ allCommentsTotal - 5 }} remaining older comments
          </font>
        </v-btn>
      </div>
      <div
        v-else
        class="no-comments-text"
      >
        <p>No comments found</p>
      </div>
    </div>
    <centre-spinner :loading="loading" />
    <review-image-dialog
      v-if="showReviewDialog"
      @reviewed-image="reviewedImage()"
      @closed="closeReviewDialog();"
    />
  </div>
</template>

<script>
import ReviewImageDialog from './ReviewImageDialog.vue';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
import Constants from 'src/constants';
export default {
  name: 'JobsComment',
  components: {
    'review-image-dialog': ReviewImageDialog,
    'centre-spinner': spinner,
  },
  filters: {
    fromNow (value) {
      return moment(value).fromNow();
    },
  },
  data: () => ({
    filesSelected: null,
    showReviewDialog: false,
    loading: false,
    lazyLoader: false,
    buttonLoader: false,
    valid: false,
    comment: '',
    imageLoad: false,
    remainingButton: false,
    paginationCheck: false,
    showGoToTopButton: 'none',
  }),
  computed: {
    firstOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    allComments () {
      const list = this.$store.getters['jobs/getAllComments'];
        if (list.length === 0) {
          return list;
        }
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
    },
    allCommentsTotal () {
      return this.$store.getters['jobs/getAllCommentsTotal'];
    },
    commentsAvailable () {
      if (this.allComments.length === 0) {
        return false;
      }
      return true;
    },
    userDetails () {
      return this.$store.getters.getUser;
    },
    jobCommentEvent () {
      return this.$store.getters['jobs/getJobCommentEvent'];
    },
  },
  async mounted () {
    this.loading = true;
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    async loadOnMount () {
      await this.$store.dispatch('jobs/clearJobComments');
      await this.getAllComments();
      await this.buttonCheck();
    },
    async getAllComments () {
      this.lazyLoader = true;
      const jobId = this.$route.params.jobId;
      await this.$store.dispatch('jobs/fetchAllComments', {
        jobId: jobId,
        params: {
          params: {
            startPage: 0,
            limit: this.paginationCheck ? this.allCommentsTotal + 1 : 5,
          },
        },
      }).then(() => {
        this.lazyLoader = false;
      }).catch(() => {
        this.lazyLoader = false;
      });
    },
    async addComment () {
      if (this.comment === '') {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please add a comment before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      };
      const jobId = this.$route.params.jobId;
      await this.$store.dispatch('jobs/addComment', {
        formData: {
          comment: this.comment,
          document_file: null,
        },
        jobId: jobId,
        orgId: this.firstOrganization.organization.external_id,
      }).then(response => {
        this.comment = '';
        this.getAllComments();
        }).catch(errors => {
      });
      this.comment = '';
    },
    buttonCheck () {
      if (this.allCommentsTotal > 4) {
        this.remainingButton = true;
        this.$store.dispatch('jobs/storeButtonValue', this.remainingButton);
      } else {
        this.remainingButton = false;
        this.paginationCheck = true;
        this.$store.dispatch('jobs/storeButtonValue', this.remainingButton);
      }
    },
    async getremainingButton () {
      this.buttonLoader = true;
      this.paginationCheck = true;
      await this.getAllComments();
      this.remainingButton = false;
      this.$store.dispatch('jobs/storeButtonValue', this.remainingButton);
      this.buttonLoader = false;
    },
    addAttachment () {
      this.$refs.fileInput.click();
    },
    handleFileChange (event) {
      const file = event.target.files[0];
      const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (file && validImageTypes.includes(file.type)) {
        this.$store.dispatch('jobs/setFiles', file);
        this.showReviewDialog = true;
      } else {
        alert('Please select a valid image file (JPEG, JPG, PNG).');
      }
    },
    closeReviewDialog () {
      this.showReviewDialog = false;
      this.$refs.fileInput.value = '';
    },
    async reviewedImage () {
      await this.getAllComments();
    },
    getImageUrl (filePath) {
      const baseUrl = process.env.VUE_APP_STORAGE_API_URL;
      return `${baseUrl}/${filePath}`;
    },
    checkUser (item) {
      if (item !== null) {
        if (this.userDetails.app_user.id === item.id) {
        return true;
      }
      return false;
      }
      return false;
    },
    goToTop () {
      document.querySelector('.comment-section').firstElementChild.scrollIntoView();
      this.$store.dispatch('jobs/jobCommentEventOccured', false);
    },
    handleScroll (event) {
      const element = event.target;
      const scrollTop = element.scrollTop;

      if (scrollTop === 0) {
        this.$store.dispatch('jobs/jobCommentEventOccured', false);
        this.showGoToTopButton = 'none';
      } else {
        this.showGoToTopButton = 'block';
      }
    },
  },
};
</script>

<style scoped>
.comment-section {
  position: relative;
  overflow-y: scroll;
  border-radius: 5px;
  background: #FFF;
  height: calc(100vh - 300px);
  padding: 10px;
}

.no-comments-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.no-comments-text p {
  color: #CCC;
}

.v-text-field  >>> .v-text-field__details {
  margin-bottom: -15px !important;
}

.v-text-field--enclosed >>> .v-input__append-inner {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.chats-style {
  display: inline-block;
  padding: 5px 15px 1px 10px;
  background: rgba(234, 234, 234, 1);
  border-radius: 5px;
  max-width: 80%;
  word-wrap: break-word;
}

.chat-style-user {
  background: #d3e2e9 !important;
}

.name-style {
  font-weight: normal;
  font-size: 11px;
  color: #838383;
}

.time-style {
  font-weight: normal;
  font-size: 12px;
  color: #CCC;
}

.empty-alert-msg {
  padding: 12px;
}

.v-progress-circular {
  margin-top: -40px;
}

.image-style {
  width: 100% !important;
}

.go-to-top {
  position: absolute;
  right: 20px;
  bottom: 80px;
  z-index: 1;
}

.go-to-top.event-triggered::after {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 100%;
  top: 0;
  left: 80%;
  background: #FF3700;
}
</style>
